import { useRouter } from 'next/router';
import { useEffect } from 'react';

interface NavigationWatcherProps {
  onNavigate: () => void;
}

const NavigationWatcher = ({ onNavigate }: NavigationWatcherProps) => {
  const router = useRouter();
  /**
   * Close the popup when navigating away
   */
  useEffect(() => {
    const handleRouteChange = () => {
      onNavigate();
    };

    router.events.on('routeChangeStart', handleRouteChange);

    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, []);

  return null;
};

export default NavigationWatcher;
